import { render, staticRenderFns } from "./shopCoopList.vue?vue&type=template&id=d6de0c54&scoped=true&"
import script from "./shopCoopList.vue?vue&type=script&lang=js&"
export * from "./shopCoopList.vue?vue&type=script&lang=js&"
import style0 from "./shopCoopList.vue?vue&type=style&index=0&id=d6de0c54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6de0c54",
  null
  
)

export default component.exports